import BindClass from "../decorators/bind-to-class"
import Utils from "../utils/utilities"
import HotlistStorage from "../decorators/hotlist-storage"
import Singleton from "../decorators/singleton"
import Routing from "../common/routing"
import EditList from "./editing"
import FixedTabs from "./fixed-tabs"
import DomUtils from "../utils/dom-utils"
import QuerySelector from "../decorators/query-selector"

const HIDE: string = 'hide'

export default class ErrorHandlers {

    @HotlistStorage
    private hotlistStorage: any

    @Singleton
    private routing: Routing

    @Singleton
    private editing: EditList

    @Singleton
    private fixedTabs: FixedTabs

    @BindClass(HIDE)
    private listOptions: boolean = false

    @BindClass(HIDE)
    private editableHeading: boolean = false

    @BindClass(HIDE)
    private errorExpired: boolean = true

    @BindClass(HIDE)
    private errorIssue: boolean = true

    @BindClass(HIDE)
    private error: boolean = true

    @BindClass(HIDE)
    private hideBreak: boolean = false

    @BindClass(HIDE)
    private expiredCreate: boolean = true

    @BindClass(HIDE)
    private expiredRemove: boolean = true

    @BindClass(HIDE)
    private nameList: boolean = true

    @BindClass(HIDE)
    private createListError: boolean = true

    @BindClass(HIDE)
    private removeListError: boolean = true

    @BindClass(HIDE)
    private renameListError: boolean = true

    @QuerySelector('[name-list]')
    private nameListElem: HTMLElement

    private errorViewChange(): void {
        this.error = false
        this.listOptions = true
        this.editableHeading = true
        this.hideBreak = true
        this.fixedTabs.updateFixedTabs()
        DomUtils.unCloak()
    }

    public handle404Errors(id: string): void {
        const filteredList: any = this.hotlistStorage.lists.filter(list => list.id === id)

        if (Utils.isDefined(filteredList) && filteredList.length > 0) {
            this.hotlistStorage.id = filteredList[0].id
            this.hotlistStorage.name = filteredList[0].name
            this.expiredRemove = false
            this.nameListElem.innerText = filteredList[0].name
            this.nameList = false
        } else if (Utils.isDefined(this.hotlistStorage.id)) {
            this.hotlistStorage.lists.forEach(list => list.active = false)
            this.expiredCreate = false
        } else {
            this.routing.routeToGetStarted(404)
            return
        }

        this.errorExpired = false
        this.errorViewChange()
    }

    public handle500Errors(id: string) {
        const filteredList: any = this.hotlistStorage.lists.filter(list => list.id === id)

        if (!(Utils.isDefined(filteredList) && filteredList.length > 0) &&
            Utils.isDefined(this.hotlistStorage.id)) this.hotlistStorage.lists.forEach(list => list.active = false)
        else if (!(Utils.isDefined(filteredList) && filteredList.length > 0)) {
            this.routing.routeToGetStarted(500)
            return
        }

        this.errorIssue = false
        this.errorViewChange()
    }

    private errorState(): void {
        this.error = false
        this.nameList = true
    }

    public getStartedErrorState(expired: boolean): void {
        this.errorState()
        this.errorExpired = !expired
        this.errorIssue = expired
    }

    public createListErrorState(): void {
        this.errorState()
        this.createListError = false
    }

    public removeListErrorState(): void {
        this.errorState()
        this.removeListError = false
    }

    public renameListErrorState(): void {
        this.errorState()
        this.renameListError = false
    }
}